import { render, staticRenderFns } from "./OrderColumnAssignedTo.vue?vue&type=template&id=3ea94b4c&"
import script from "./OrderColumnAssignedTo.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnAssignedTo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports